import { inject, Pipe, PipeTransform } from '@angular/core';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';

@Pipe({
	name: 'currency',
})
export class CurrencyPipe implements PipeTransform {
	private setupPageService = inject(SetupPageService);

	transform(value: number): string {
		const country = this.setupPageService.getCurrentCountry();

		if (!country || value == null || isNaN(value)) {
			return String(value ?? '');
		}

		const { locale, currency } = country;

		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency,
			maximumFractionDigits: 0,
		}).format(value);
	}
}
